import { useConnectors } from 'wagmi';
import { WALLET_ORDER } from '../utils/constants';

const isMobile = () => /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

const MOBILE_WC_FALLBACK_WALLETS = ['MetaMask', 'Binance Wallet'];

export const useWalletList = () => {
  const connectors = useConnectors();
  const mobile = isMobile();
  const hasWalletConnect = connectors?.some(c =>
    c.name?.toLowerCase()?.includes('walletconnect')
  );

  return WALLET_ORDER?.map(walletName => {
    const connector = connectors?.find(c =>
      c.name?.toLowerCase()?.includes(walletName?.toLowerCase())
    );

    const canFallbackToWC = mobile && hasWalletConnect &&
      MOBILE_WC_FALLBACK_WALLETS.includes(walletName);

    return {
      name: walletName,
      connector: connector,
      isAvailable: !!connector || canFallbackToWC
    };
  });
};